var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUdsNeedsImage30(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.98,55c-13.82,0-24.98-11.19-24.96-25.02,.02-13.83,11.22-25.01,25.02-24.98,13.78,.03,24.95,11.28,24.93,25.1-.02,13.73-11.23,24.9-24.99,24.9Zm-11.23-28.25c-1.74,.24-2.9,.98-3.52,2.4-.67,1.51-.36,2.94,.79,4.13,2.36,2.41,4.71,4.83,7.13,7.19,2.49,2.42,6.22,2.33,8.65-.17,.72-.74,1.38-1.54,2.07-2.32,3.46-3.95,6.92-7.9,10.39-11.84,.82-.93,1.4-1.94,1.23-3.21-.21-1.54-1.04-2.64-2.55-3.09-1.49-.45-2.81-.08-3.85,1.09-3.17,3.6-6.32,7.2-9.48,10.81-1.61,1.84-2.93,1.9-4.63,.19-1.24-1.25-2.43-2.57-3.75-3.73-.7-.62-1.65-.97-2.48-1.44Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUdsNeedsImage30);
export default __webpack_public_path__ + "static/media/UDS Needs Image-30.9b28ed8f14c4f4fe9b5df71e0ff37473.svg";
export { ForwardRef as ReactComponent };